import PropTypes from "prop-types";
import React from "react";
import { Modal, ModalBody, Spinner } from "reactstrap";
import { CommonLabel } from "../../utils/helpers/common";

const ApproveRejectModal = ({ show, onDeleteClick, onCloseClick ,message, action, loader, closeLabel, submitLabel, hideTitle }) => {
  return (
    <Modal fade={true} isOpen={show} toggle={onCloseClick} centered={true}>
      <ModalBody className="py-3 px-5">
        <div className="mt-2 text-center">
          <lord-icon
            src="https://cdn.lordicon.com/gsqxdxog.json"
            trigger="loop"
            colors="primary:#f7b84b,secondary:#f06548"
          ></lord-icon>
          <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
            {!hideTitle && (<h4>{CommonLabel.BasicConfirmation}</h4>)}
            <p className="text-muted mx-5 mb-0">
              {message || CommonLabel.RecordConfirmation}
            </p>
          </div>
        </div>
        <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
          <button
            type="button"
            className="btn w-sm btn-light"
            data-bs-dismiss="modal"
            onClick={onCloseClick}
          >
            {closeLabel || CommonLabel.Close}
          </button>
          <button
            type="button"
            className="btn w-sm btn-danger "
            id="delete-record"
            onClick={onDeleteClick}
          >
            {loader && <Spinner size="sm" className="me-2" />}
            {submitLabel || CommonLabel.Yes}
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};

ApproveRejectModal.propTypes = {
  onCloseClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  show: PropTypes.any,
  message: PropTypes.string,
  action: PropTypes.string,
};

export default ApproveRejectModal;